export var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus["ACTIVE"] = "active";
    PromotionStatus["INACTIVE"] = "inactive";
    PromotionStatus["EXPIRED"] = "expired";
    PromotionStatus["PENDING_APPROVAL"] = "pending_approval";
    PromotionStatus["REJECTED"] = "rejected";
})(PromotionStatus || (PromotionStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvbW90aW9uU3RhdHVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL25la28tcG9zL1Byb21vdGlvblN0YXR1cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxlQU1YO0FBTkQsV0FBWSxlQUFlO0lBQ3pCLG9DQUFpQixDQUFBO0lBQ2pCLHdDQUFxQixDQUFBO0lBQ3JCLHNDQUFtQixDQUFBO0lBQ25CLHdEQUFxQyxDQUFBO0lBQ3JDLHdDQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFOVyxlQUFlLEtBQWYsZUFBZSxRQU0xQiJ9